export enum ProjectGroup {
  AssignedProjects = 'Assigned projects',
  OtherProjects = 'Other projects',
}
